"use client";

import { memo } from "react";
import { CareerBenefits } from "@/lib/content";

const BenefitCard = memo(({ benefit }) => {
  const Icon = benefit.icon;
  
  return (
    <div 
      className="flex items-center gap-6 border-2 border-black rounded-3xl p-6 bg-white transition-transform hover:-translate-y-1"
      role="listitem"
    >
      <div 
        className="flex-shrink-0 w-16 h-16 flex items-center justify-center bg-black rounded-2xl"
        aria-hidden="true" 
      >
        <Icon size={28} className="text-white" />
      </div>
      <div>
        <h3 className="text-xl font-bold tracking-tight text-black">
          {benefit.title}
        </h3>
        <p className="text-gray-600 text-sm mt-1">{benefit.description}</p>
      </div>
    </div>
  );
});

BenefitCard.displayName = "BenefitCard";

export default function BenefitsSection() {
  return (
    <section 
      className="w-full bg-[#4F7AC2] py-20" 
      aria-labelledby="benefits-heading"
    >
      <div className="max-w-7xl mx-auto px-6">
        <header className="max-w-3xl mb-16">
          <h2 
            id="benefits-heading" 
            className="text-4xl text-white md:text-5xl font-bold mb-6 tracking-tight"
          >
            {CareerBenefits.title}
          </h2>
          <p className="text-white/90 text-xl leading-relaxed">
            {CareerBenefits.description}
          </p>
        </header>

        {/* 3. Use a list role for better accessibility navigation */}
        <div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          role="list"
        >
          {CareerBenefits.benefits.map((benefit) => (
            <BenefitCard key={benefit.title} benefit={benefit} />
          ))}
        </div>
      </div>
    </section>
  );
}